module.exports = __webpack_public_path__ + "img/consult_info3.cb54f522.png";